<div class="row row1">
    <div class="col-sm-12 overview-header-container">
        <h2 class="overview-header">Overview</h2>
    </div>
</div>
<div class="row row2">
  <div class="col-sm-3">
    <div class="panel panel-card usage-top-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <app-account-details></app-account-details>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-1"></div>
  <div class="col-sm-8 current-bill-container right-page-column">
    <app-current-bill></app-current-bill>
  </div>
</div>
<div class="row row3">
  <div class="col-sm-7">
    <app-power-usage></app-power-usage>
  </div>
  <div class="col-sm-5">
    <app-billing-history></app-billing-history>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/page/page.component.html